import {animate, state, style, transition, trigger} from '@angular/animations';
import {ChangeDetectionStrategy, Component, NgZone} from '@angular/core';
import {Toast, ToastPackage, ToastrService} from 'ngx-toastr';
import {NgClass} from '@angular/common';
import {CovIconComponent} from '../cov-icon/cov-icon.component';
import {IconName} from '../../enums/icon.enum';
import {ToastTypeEnum} from '../../enums/toast-type.enum';
import {CovToastConfigPayloadInterface} from '../../interfaces/cov-toast-config-payload.interface';

@Component({
  selector: 'cov-toast',
  styleUrl: './cov-toast.component.scss',
  templateUrl: './cov-toast.component.html',
  imports: [CovIconComponent, NgClass],
  animations: [
    trigger('flyInOut', [
      state('inactive', style({opacity: 0, transform: 'translateY(-10px)'})),
      state('active', style({opacity: 1, transform: 'translateY(0)'})),
      state('removed', style({opacity: 0, transform: 'translateY(10px)'})),
      transition('inactive => active', animate('{{ easeTime }}ms ease-out')),
      transition('active => removed', animate('{{ easeTime }}ms ease-in')),
    ]),
  ],
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CovToastComponent extends Toast<CovToastConfigPayloadInterface> {
  protected readonly IconName = IconName;

  public iconName: IconName = this._getIconName();

  public progressBarCss = this._getProgressBarClass();

  constructor(toastrService: ToastrService, toastPackage: ToastPackage, ngZone?: NgZone) {
    super(toastrService, toastPackage, ngZone);
  }

  private _getIconName() {
    switch (this.options.payload?.type) {
      case ToastTypeEnum.SUCCESS:
        return IconName.CHECK;
      case ToastTypeEnum.ERROR:
        return IconName.WARNING;
      default:
        return IconName.INFO;
    }
  }

  private _getProgressBarClass() {
    return {
      'cov-toast-progress-bar-info': this.options.payload?.type === ToastTypeEnum.INFO,
      'cov-toast-progress-bar-error': this.options.payload?.type === ToastTypeEnum.ERROR,
      'cov-toast-progress-bar-success': this.options.payload?.type === ToastTypeEnum.SUCCESS,
    };
  }
}
